<template>
  <CustomHeaderModal
    :isShowModal="isShowModal"
    @cancel="cancel">
    <!-- ヘッダー -->
    <header class="card-header">
      <div class="cover-filter">
        <p class="card-header-title">
          {{user.name}} - 詳細
        </p>
      </div>
    </header>
    <div class="create-menu">
      <div class="-body">
        <div class="data-box">
          <p class="-label">Eメール</p>
          <p class="-data">{{user.email}}</p>
        </div>
        <div class="data-box">
          <p class="-label">一言</p>
          <p class="-data">{{user.message}}</p>
        </div>
        <div class="data-box">
          <p class="-label">自己紹介</p>
          <p class="-data">{{user.description}}</p>
        </div>
        <div class="data-box">
          <p class="-label">一日の予定</p>
          <p class="-data">{{user.schedule}}</p>
        </div>
        <div class="data-box">
          <p class="-label">所属: 仕事内容</p>
          <p class="-data">{{user.career}}</p>
        </div>
      </div>
      <div class="footer-box">
        <button class="button nav-button" @click="cancel()">
          閉じる
        </button>
      </div>
    </div>
  </CustomHeaderModal>
</template>

<script>
import CustomHeaderModal  from '@/components/Modals/CustomHeaderModal'
export default {
  components: {
    CustomHeaderModal,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.cover-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .card-header-title {
    font-size: 24px;
    font-weight: 600;
  }
  .nav-button {
    color: #a22;
    border: solid 2px #a22;
    font-weight: 800;
  }
  div {
    display: flex;
    button {
      margin: 8px;
    }
  }
}

.create-menu {
  width: 100%;
  padding: 24px;
  overflow-y: scroll;
  .-title {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
  }
  .-body {
    width: 100%;
    .data-box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 64px;
      border: solid thin #ccc;
      .-label {
        width: 200px;
        height: 100%;
        font-weight: 600;
        text-align: left;
        background: #ffeeff;
        padding: 8px;
        border: solid thin #ccc;
      }
      .-data {
        height: 100%;
        width: calc(100% - 200px);
        background: #f9f9f9;
        text-align: left;
        overflow-y: scroll;
        padding: 8px;
        border: solid thin #ccc;
      }
    }
  }
  .footer-box {
    border-top: solid thin #ccc;
    width: 100%;
    margin-top: 32px;
    padding: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VirtualOffice/organisms/ModalDetailProfile.vue